exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".team-cards-due-empty__empty__3gi8R {\n  align-items: center;\n  background-color: #EBEEF0;\n  border-radius: 4px;\n  color: #6B808C;\n  display: flex;\n  height: 24px;\n  justify-content: center;\n  margin: -8px 8px 40px 8px;\n  padding: 8px;\n}\n.team-cards-due-empty__emptyToday__32zvn {\n  align-items: center;\n  border-top: 1px solid #EBEEF0;\n  display: flex;\n  flex-direction: column;\n  margin: -8px 8px 40px 8px;\n  padding: 16px;\n}\n.team-cards-due-empty__image__1XZuu {\n  display: block;\n}\n.team-cards-due-empty__title__WBsd9 {\n  font-size: 16px;\n  font-weight: bold;\n  margin-top: 12px;\n}\n.team-cards-due-empty__subtitle__1m0e6 {\n  color: #6B808C;\n}\n", ""]);

// exports
exports.locals = {
	"empty": "team-cards-due-empty__empty__3gi8R",
	"emptyToday": "team-cards-due-empty__emptyToday__32zvn",
	"image": "team-cards-due-empty__image__1XZuu",
	"title": "team-cards-due-empty__title__WBsd9",
	"subtitle": "team-cards-due-empty__subtitle__1m0e6"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":2,"localIdentName":"[name]__[local]__[hash:base64:5]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2113/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/team-cards-due-empty.less
// module id = I7dm
// module chunks = 1